jQuery($ => {
    class ImageBlurbCarousel {
      constructor(element) {
        this._           = element;
        this._element    = $(element);
        this._slider     = this._element.find('enhanced-css-slider');
        this._slides     = this._element.find('.o-image-blurb-carousel__item:not(.fake)');
        this._navigation = this._element.find('.o-image-blurb-carousel__navigation');
  
        this.init();
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      init() {
        this.setupHandlers();
        this._element.trigger( 'init', this );
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      setupHandlers() {
        this._slider.on('slideStarted', event => {
          const nextIndex = event.detail.nextSlide;
          const nextSlide = this._slides[nextIndex];
          
          if (nextSlide.classList.contains('o-image-blurb-block--background-light-gray')) {
            this._navigation.removeClass('m-slider-navigation--inverted');
            this._navigation.find('.a-arrow-button').removeClass('a-arrow-button--inverted-outline');
            this._navigation.find('.a-arrow-button').addClass('a-arrow-button--primary');
          } else {
            this._navigation.addClass('m-slider-navigation--inverted');
            this._navigation.find('.a-arrow-button').removeClass('a-arrow-button--primary');
            this._navigation.find('.a-arrow-button').addClass('a-arrow-button--inverted-outline');
          }
        });
      }
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $.fn.image_blurb_carousel = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == 'object' || typeof opt == 'undefined')
          _[i].image_blurb_carousel = new ImageBlurbCarousel(_[i], opt);
        else
          ret = _[i].image_blurb_carousel[opt].apply(_[i].image_blurb_carousel, args);
        if (typeof ret != 'undefined') return ret;
      }
      return _;
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $('.o-image-blurb-carousel').image_blurb_carousel();
});